import {useState} from 'react';
import {toast} from 'sonner';
import {api, currency, errorMessage} from '../lib/api';
import {Field, SelectField, Submit, ErrorBox} from './Common';

const checks = [
  ['contact_verified', 'Contact identity independently verified'],
  ['eligibility_confirmed', 'Eligibility, jurisdiction and any required identity checks completed'],
  ['documents_reviewed', 'Applicable investment documents reviewed and completed as required'],
  ['company_approval', 'Company authorization to proceed recorded'],
  ['instructions_verified', 'Receiving instructions independently verified by an authorized representative'],
];
const references = [
  ['issuing_entity', 'Issuing entity'], ['jurisdiction', 'Jurisdiction'],
  ['investment_instrument', 'Investment instrument'], ['document_reference', 'Approved document reference'],
  ['instructions_reference', 'Verified payment-instructions reference'],
];

export const GuestReviewForm = ({record, onSave}) => {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const review = record.guest_review || {};
  async function submit(event) {
    event.preventDefault(); setError(''); setBusy(true);
    const form = Object.fromEntries(new FormData(event.target));
    checks.forEach(([name]) => {form[name] = form[name] === 'on';});
    try {
      const {data} = await api.patch(`/admin/guest-interests/${record.id}/review`, form);
      toast.success('Guest interest review saved.'); onSave(data);
    } catch (failure) {setError(errorMessage(failure));}
    finally {setBusy(false);}
  }
  return <><div className="guest-review-summary" data-testid="guest-review-summary">
    <strong data-testid="guest-review-amount">{currency(record.guest_interest.amount)}</strong>
    <span className="status-tag">NONBINDING · GUEST</span>
    <p data-testid="guest-review-details">{record.organization} · {record.country} · {record.guest_interest.structure} · {record.guest_interest.timeline}</p>
    <p data-testid="guest-review-message">{record.message || 'No additional message.'}</p>
    <p className="caption" data-testid="guest-review-topics">Interests: {record.interests.join(', ')}</p>
  </div>
  <form onSubmit={submit} data-testid="guest-review-form">
    <div className="form-grid">
      <SelectField label="Review stage" name="stage" defaultValue={review.stage || 'New interest'} options={['New interest', 'Under review', 'Awaiting documents', 'Ready for private follow-up', 'Instructions shared privately', 'Payment review pending', 'Not proceeding']}/>
      <Field label="Relationship owner" name="owner" defaultValue={record.owner} maxLength={120}/>
    </div>
    <Field label="Review notes" name="notes" textarea rows={3} defaultValue={record.notes} maxLength={10000}/>
    <h3 className="guest-review-subheading" data-testid="guest-review-checks-title">Before private bank-transfer instructions</h3>
    {checks.map(([name, label]) => <label className="check-label" key={name}>
      <input type="checkbox" name={name} data-testid={`guest-review-${name.replaceAll('_','-')}`} defaultChecked={name === 'eligibility_confirmed' ? record.eligibility_confirmed : review[name]}/><span>{label}</span>
    </label>)}
    <div className="form-grid">{references.map(([name, label]) => <Field key={name} label={label} name={name} defaultValue={review[name] || ''} maxLength={name.endsWith('reference') ? 1000 : 200}/>)}</div>
    <div className="notice" data-testid="guest-review-boundary">These are internal review records, not a payment service. No instructions are sent automatically. Share approved instructions privately only after all checks and financing approval. This does not confirm receipt of funds or issue shares.</div>
    <ErrorBox error={error}/><Submit busy={busy} id="guest-review-save">Save review</Submit>
  </form></>;
};